import { all } from 'redux-saga/effects';
import { watchList } from './list';
import { watchCreate } from './create';
import { watchDelete } from './delete';
import { watchUpdate } from './update';
import { watchGet } from './get';
import watchReset from './reset';

export function* watchFieldRepresentatives() {
  yield all([
    watchList(),
    watchCreate(),
    watchDelete(),
    watchUpdate(),
    watchGet(),
    watchReset(),
  ]);
}
